import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import * as _ from 'lodash';

import { MarketingPluginService } from './marketing-plugin.service';
import { BaseModalPageComponent } from '../../base-modal.component';

import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PresentationsModalComponent } from '../../../app/shared/components';
import { ConnectionCheck } from '../../utils/connection-check';

@Component({
    selector: 'marketing-edit',
    templateUrl: './marketing-edit.component.html',
    standalone: false
})
export class MarketingPluginPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public plugin: any;
  public processing = false;

  public links: any[];

  editForm: FormGroup;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true }) deleteConfirm: ConfirmComponent;
  @ViewChild('presentationsModal', { static: true }) presentationsModal: ModalComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private service: MarketingPluginService,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
    this.editForm = new UntypedFormGroup({
      description: new UntypedFormControl('')
    });
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.goToBack();

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.goToBack();

      this.pointId = pointId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      this.initData();
    });
  }

  save() {
    this.processing = true;
    this.service
      .updateMarketing(this.inspectionId, this.pointId, this.pluginId, {
        Description: this.editForm.controls['description'].value,
        Links: this.links
      })
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel() {
    this.goToBack();
  }

  ngOnInit() {
    this.initRoute();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.links = this.plugin.config?.Links?.map((x: any) => Object.assign({}, x));
      if (!this.links || this.links.length === 0) {
        this.links = [];
      }
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  openPresentationsPickerMOdal(): void {
    this.presentationsModal.hasClassModal = true;
    this.presentationsModal.open(PresentationsModalComponent, {});
  }

  addPresentations(event) {
    this.links = _.uniqBy([...this.links, ...event], 'Id');
  }

  open(url) {
    window.open(url, '_blank').focus();
  }

  remove(index: number) {
    this.links.splice(index, 1);
  }

  navigateTo(url) {
    window.open(url, '_blank').focus();
  }

  initForm() {
    this.editForm.controls['description'].setValue(this.plugin?.config?.Description);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      default:
    }
  }

  gotoEditJsonPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'editjson'
    ]);
  }

  gotoEditPage() {
    return this.router.navigate([
      this.inspectionsRoute,
      this.inspectionId,
      'points',
      this.pointId,
      'plugins',
      this.pluginId,
      'edit'
    ]);
  }

  openDeleteConfirm() {
    this.deleteConfirm.open();
  }

  deletePlugin() {
    this.service.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  public get isConnection() {
    return ConnectionCheck.isConnection;
  }
}
